import { Mui } from "@osu/react-ui";

const CompQualities = (props) => {
  const {
    studentData,
    renderInputControls
  } = props;
  
  return (
    <Mui.Container>
      <div style={{ display: "flex" }}>
        <Mui.FormControl component="fieldset">
          <Mui.FormLabel component="legend">
            {studentData?.data?.notes?.competitive && <Mui.Typography variant="h6" component="h3" >Competitive Application Attributes</Mui.Typography>}
          </Mui.FormLabel>
          <Mui.FormGroup>   
           {renderInputControls(studentData?.data?.notes?.competitive, "competitive")}
          </Mui.FormGroup>
        </Mui.FormControl>
      </div>
    </Mui.Container>
  );
};
export default CompQualities;
